import { PlayIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import type { TranslationKey } from '@/i18n/types'
import { cn } from '@/lib/utils'

import { VideoPlayerDialog } from './video-player-dialog'

type Props = {
  defaultOpen?: boolean
  featured?: boolean
  onOpenChange?(open: boolean): void
  titleKey: TranslationKey
  youtubeId: string
}

export const VideoCard = ({
  defaultOpen,
  featured = false,
  onOpenChange,
  titleKey,
  youtubeId,
}: Props) => {
  const { t } = useTranslation()
  const title = t(titleKey)

  return (
    <VideoPlayerDialog
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      title={title}
      trigger={
        <button
          className="flex flex-col rounded-lg bg-white p-3 text-left shadow-md transition-shadow hover:shadow-lg"
          type="button"
        >
          <div className="relative aspect-video overflow-hidden rounded-md bg-layer-2">
            <img
              alt={title}
              className="h-full w-full object-cover"
              src={`https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`}
            />
            <div className="absolute inset-0 flex items-center justify-center bg-black/20">
              <div className="flex size-10 items-center justify-center rounded-full bg-white/90">
                <PlayIcon className="ml-0.5 size-5 fill-current" />
              </div>
            </div>
          </div>
          <span className={cn('mt-3 text-sm font-medium', { 'text-base': featured })}>{title}</span>
        </button>
      }
      youtubeId={youtubeId}
    />
  )
}

export default VideoCard
